import { ORDER_EVENT_TOPICS, type OrderEventTopic } from "./protocol";
export { ORDER_EVENT_TOPICS, type OrderEventTopic } from "./protocol";
export const ORDER_DATA_INVALIDATED_EVENT = "cfmoto:order-data-invalidated";

export function parseOrderEventTopics(raw: string): OrderEventTopic[] {
  try {
    const value: unknown = JSON.parse(raw);
    if (!value || typeof value !== "object" || !("topics" in value)) return [];
    const topics = value.topics;
    if (!Array.isArray(topics)) return [];
    return ORDER_EVENT_TOPICS.filter((topic) => topics.includes(topic));
  } catch {
    return [];
  }
}
